import { createFileRoute } from "@tanstack/react-router";

import { AthletePageTabsLayout } from "src/pages/AthletePageTabsLayout";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/programs/_tabs",
)({
  component: AthletePageTabsLayout,
});
